import ReferFriends from '../../images/ReferFriend.png';
function ReferFriend() {
    return (
        <div style={{ marginLeft: '2.5px', marginRight: '20px', marginTop: '20px' }}>
            <img src={ReferFriends} style={{ width: '100%', height: '' }} alt="" />
        </div>
    );
}
export default ReferFriend;